import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessFlowAuditService {
  private http = inject(HttpClient);
  private url = Global.url;

  getLatest(processKey: string | number): Observable<any> {
    return this.http.get<any>(`${this.url}V1/process-flow-audit/${processKey}/latest`);
  }

  list(params?: { processSlug?: string | null; limit?: number; offset?: number }): Observable<{
    rows: any[];
    total: number;
    limit: number;
    offset: number;
  }> {
    const q: string[] = [];
    if (params?.processSlug) q.push(`processSlug=${encodeURIComponent(params.processSlug)}`);
    if (params?.limit != null) q.push(`limit=${params.limit}`);
    if (params?.offset != null) q.push(`offset=${params.offset}`);
    const qs = q.length ? `?${q.join('&')}` : '';
    return this.http.get<any>(`${this.url}V1/process-flow-audit${qs}`);
  }

  rollback(auditId: string | number, options?: { applyToOpen?: boolean }): Observable<any> {
    return this.http.post<any>(`${this.url}V1/process-flow-audit/${auditId}/rollback`, {
      applyToOpen: !!options?.applyToOpen
    });
  }
}
